import { HeaderWrapper } from 'layouts';
import type { Media, VideoContentObject } from 'models';
import { HeaderContent } from 'ui';
import { useGetVideoStatusTagProperties } from '../../../hooks';
import { VideoHeaderAsset } from '../video-header-asset';

type P = {
  trailerData?: Media;
  videoContentObject: VideoContentObject;
};

const VideoDetailArchivedHeader = ({ trailerData, videoContentObject }: P) => {
  const getStatusTagProperties = useGetVideoStatusTagProperties();

  return (
    <HeaderWrapper
      left={<VideoHeaderAsset trailerData={trailerData} videoContentObject={videoContentObject} />}
      right={
        <HeaderContent
          tags={getStatusTagProperties({ status: videoContentObject.video.status })}
          timeInfo={{ date: videoContentObject.video.recordedAt }}
          title={videoContentObject.video.name}
        />
      }
    />
  );
};

export default VideoDetailArchivedHeader;
